import { classInstance } from '@/shared/helpers/helpers';
import { CodeForm } from '@/features/authorization/code-form/code-form';

/**
 * Вход-регистрация по телефону. Управляет переключением форм с ввода телефона на код и обратно.
 * 
 * Взаимодействия с сервером не предполагает, коллбэков не принимает. 
 * @category 6 Авторизация
 * @example
 * window.app.loginTel = new AuthorizationTel(document.querySelector('#login-tel'));
 * @constructor
 * @param {HTMLFormElement} element HTML-элемент
 */

export class AuthorizationTel {
	private readonly element: HTMLElement | null;
	private formElement: HTMLFormElement | null;
	codeElement: HTMLFormElement | null;
	private code: CodeForm | null;
	private backButton: HTMLButtonElement | null;
	private readonly codeClass: string = 'authorization-tel--code';

	constructor(element: HTMLElement) {
		if (!element) return;
		this.element = element;
		this.init();
	}

	/**
	 * Обработчик успешной отправки номера. Показывает форму кода
	 */
	private handleFormSubmit = ({ detail }): void => {
		this.element.classList.add(this.codeClass);
		this.code.setTimer();
		this.code.setNumber(detail.data.tel);
	};

	/**
	 * Обработчик клика по кнопке «назад». Показывает форму телефона
	 */
	private handleBackClick = () => this.element.classList.remove(this.codeClass);

	/**
	 * Инициализация экземпляра:
	 * * элементы, не создаваемые напрямую из аргументов конструктора;
	 * * обработчики событий.
	 */
	public init = (): void => {
		classInstance.set(this.element, { authorizationTel: this });
		this.formElement = this.element.querySelector('.authorization-tel__form');
		this.formElement.addEventListener('formSubmit', this.handleFormSubmit);
		this.codeElement = this.element.querySelector('.authorization-tel__code');
		this.backButton = this.element.querySelector('.code-form__tel');
		this.backButton.addEventListener('click', this.handleBackClick);
		this.code = classInstance.get(this.codeElement).codeForm;
	};

	/**
	 * Уничтожение экземпляра:
	 * * обнуление элементов;
	 * * удаление обработчиков.
	*/
	public вуыекщн = (): void => {
		classInstance.del(this.element, 'authorizationTel');
		this.formElement.removeEventListener('formSubmit', this.handleFormSubmit);
		this.backButton.removeEventListener('click', this.handleBackClick);
		this.formElement = null;
		this.codeElement = null;
		this.backButton = null;
		this.code = null;
	};
}
